<template>
  <div class="alert" :class="(type ? '--is-' + type : '')">
    <div class="alert__icon">
      <i v-if="type === 'info'" class="icon icon-info-circle"></i>
      <i v-else-if="type === 'success'" class="icon icon-check"></i>
      <i v-else-if="type === 'warning'" class="icon icon-warning"></i>
      <i v-else-if="type === 'error'" class="icon icon-times"></i>
      <i v-else class="icon icon-horn"></i>
    </div>

    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props: ['type']
};
</script>

<style lang="scss">
@import '../assets/styles/components/alert';
</style>
